export default "<span class=\"icon\" *ngIf='svg' [innerHtml]='svg|safeHtml'>\r\n\r\n</span>"